<template>
	<div class="c-input-folders-dropdown">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<div tabindex="1" class="c-input-folders-dropdown__input form-control" @mouseup="onInputClick($event)" ref="popupBoard">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M2 10.5H22M22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H7.79844C8.25258 4 8.6932 4.15456 9.04783 4.43826L10.4522 5.56174C10.8068 5.84544 11.2474 6 11.7016 6H19C20.6569 6 22 7.34315 22 9Z"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-width="1.5"
				/>
			</svg>

			<span v-if="currentFolder">
				{{ currentFolder.name }}
			</span>
		</div>
		<PopupFolder placement="bottom" v-if="hasMounted" :active="active" :target="target" @onClose="active = false">
			<div :class="['c-input-folders-dropdown__item', { active: currentFolder && currentFolder.id === folder.id }]" v-for="folder in currentFolders" :key="folder.id" @click="onFolderClick(folder)">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M2 10.5H22M22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H7.79844C8.25258 4 8.6932 4.15456 9.04783 4.43826L10.4522 5.56174C10.8068 5.84544 11.2474 6 11.7016 6H19C20.6569 6 22 7.34315 22 9Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-width="1.5"
					/>
				</svg>
				<span>
					{{ folder.name }}
				</span>
			</div>
		</PopupFolder>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription v-if="description" :message="description"></InputDescription>
	</div>
</template>

<script>
import PopupFolder from '@swipekit/components/popup/popup-folder';
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
	components: {
		PopupFolder,
		InputError,
		InputDescription,
	},

	data: function () {
		return {
			hasMounted: false,
			active: false,

			currentFolder: null,
		};
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		validation: {},
		value: {},
		placeholder: {
			type: String,
			default: '',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
	},

	watch: {
		value: {
			handler: function () {
				let value = this.value;

				if (!value) {
					if (this.defaultFolder) {
						this.currentFolder = this.defaultFolder;
						return;
					} else {
						this.currentFolder = null;
						return;
					}
				}

				let folder = null;
				let folders = this.folders;

				for (let i = 0; i < folders.length; i++) {
					let f = folders[i];
					if (f.id === this.value) {
						folder = f;
						break;
					}
				}

				if (folder) {
					this.currentFolder = folder;
				}

				if (!folder) {
					if (this.defaultFolder) {
						this.currentFolder = this.defaultFolder;
					}
				}
			},
			immediate: true,
		},
		currentFolders: function (newz, old) {
			// this.onChange({
			// 	target: {
			// 		value: this.currentFolders,
			// 	},
			// });
		},
	},

	computed: {
		defaultFolder: function () {
			if (!this.folders) {
				return;
			}
			let folders = this.folders;
			let defaultFolder = null;
			for (let i = 0; i < folders.length; i++) {
				const f = folders[i];
				if (f.default) {
					defaultFolder = f;
					break;
				}
			}

			return defaultFolder;
		},
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
		computedCurrentFolders: function () {
			let boards = JSON.parse(JSON.stringify(this.currentFolders));

			for (let i = 0; i < boards.length; i++) {
				boards[i] = this.$store.getters['boards/one'](boards[i]);
			}

			return boards;
		},
		target: function () {
			return this.$refs.popupBoard;
		},
		folders: function () {
			return this.$store.getters['folders/filtered'];
		},
		currentFolders: function () {
			return this.folders;
		},
	},

	methods: {
		onFolderClick: function (folder) {
			this.$emit('input', folder.id);
		},
		onInputClick: function (e) {
			if (e.target.closest('.c-input-boards-dropdown__input .btn')) {
				return;
			}

			this.active = !this.active;
		},
		onChange: function (e) {
			let value = e.target.value;
			this.$emit('input', value);
		},
	},

	created: function () {},

	mounted: function () {
		this.hasMounted = true;
	},
};
</script>

<style lang="scss">
.c-input-folders-dropdown {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);
	width: 100%;

	.close {
		font-family: 'icomoon' !important;
		speak: none;
		font-style: normal;
		font-weight: normal;
		font-variant: normal;
		text-transform: none;
		line-height: 1;
		-webkit-font-smoothing: antialiased;
		&:after {
			content: '\e901';
		}
	}

	.c-input-boards {
		padding-bottom: 0;
	}

	.c-popup-folder {
		.c-popup {
			overflow: hidden;
		}
	}

	&__input {
		cursor: pointer;
		display: inline-flex !important;
		padding-left: var(--margin) !important;
		align-items: center;

		svg {
			margin-right: var(--margin);
		}
	}

	&__item {
		padding: var(--margin);
		font-size: var(--font-size-sm);
		display: flex;
		align-items: center;
		cursor: pointer;

		svg {
			margin-right: var(--margin);
		}

		&:hover,
		&:active {
			background-color: var(--color-bg-3);
		}

		&.active {
			background-color: var(--color-primary);
			color: var(--color-button-font);
		}
	}
}
</style>
